import { useEffect } from 'react';

export function useKeyPress(callback: () => void, keyNames: string[]): void {
  const handler = ({ code }: KeyboardEvent) => {
    if (keyNames.includes(code)) {
      callback();
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handler);
    return () => {
      window.removeEventListener('keydown', handler);
    };
  }, []);
}
